import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TermsAcceptanceModal } from '@ibk/shared-ui';
import { TERMS_ACCEPTANCE_GATE_DEFAULT_TEST_ID } from '@ibk/shared-utils';
import { useTermsAcceptanceGate } from './useTermsAcceptanceGate';
export const TermsAcceptance = ({ children, enabled = true, userId, deferPendingUntilUserId = false, termsHtml, termsModalChildren, 'data-testid': testId = TERMS_ACCEPTANCE_GATE_DEFAULT_TEST_ID, }) => {
    const { gateReady, modalOpen, presentation, handleAccept } = useTermsAcceptanceGate({
        enabled,
        userId,
        deferPendingUntilUserId,
    });
    return (_jsxs(_Fragment, { children: [enabled && gateReady && modalOpen && (_jsx(TermsAcceptanceModal, { isOpen: true, onAccept: handleAccept, modalTitle: presentation?.title, termsDocumentUrl: termsHtml == null ? presentation?.documentUrl : undefined, termsHtml: termsHtml ?? presentation?.html, "data-testid": `${testId}-modal`, children: termsModalChildren })), children] }));
};
